/* @flow */
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import type { QuickActionType } from 'entities/QuickActions';
import QuickActionsBar from 'chat/components/QuickActionsBar.jsx';
import Group from 'entities/Group';
import { loadQuickActions } from 'reducers/quickActions';

type Props = {
  group: Group,
  actions: ?QuickActionType[],
  loadQuickActions: (groupId: number) => void,
};

class QuickActionsBarContainer extends React.Component {
  props: Props;

  componentWillMount() {
    if (!this.props.actions) {
      this.props.loadQuickActions(this.props.group.id);
    }
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.group !== this.props.group && !newProps.actions) {
      newProps.loadQuickActions(newProps.group.id);
    }
  }

  render() {
    if (this.props.actions && this.props.actions.length > 0) {
      return (
        <div>
          <div className="ChatList-list-header">
            Quick Actions
          </div>
          <QuickActionsBar
            actions={this.props.actions}
            group={this.props.group}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state: Object, props: Object): Object => {
  const quickActions = state.quickActions.get(props.group.id);
  if (!quickActions) {
    return {};
  }

  return { actions: quickActions.actions };
};

const mapDispatchToProps = (dispatch: Function): Object =>
  bindActionCreators({
    loadQuickActions,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QuickActionsBarContainer);



// WEBPACK FOOTER //
// ./src/chat/components/QuickActionsBarContainer.jsx